import { createContext } from "react";
import { IContext } from "./game.types";

export const Context = createContext<IContext | undefined>(undefined);
